import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'input-control',
    templateUrl: './input-control.component.html',
    styleUrls: ['./input-control.component.scss']
})
export class InputControlComponent implements OnInit, AfterViewInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit() {
        this.control.code = '';
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
